import { render } from "./ProfileMainMenu.vue?vue&type=template&id=9500ca54&scoped=true"
import script from "@/wwwroot/js/profileMainMenu.js?vue&type=script&lang=js"
export * from "@/wwwroot/js/profileMainMenu.js?vue&type=script&lang=js"

import "@/wwwroot/css/profileMainMenu.css?vue&type=style&index=0&id=9500ca54&scoped=true&lang=css"
import "@/wwwroot/css/sharedStyles.css?vue&type=style&index=1&id=9500ca54&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9500ca54"]])

export default __exports__